export function startBrowserDownload(documentElement: any, url: string): void {
  const downloadAnchor = documentElement.createElement('a');
  downloadAnchor.setAttribute('href', url);
  downloadAnchor.setAttribute('download', '');
  downloadAnchor.setAttribute('type', 'hidden');
  documentElement.body.appendChild(downloadAnchor);
  downloadAnchor.click();
  documentElement.body.removeChild(downloadAnchor);
}
